import { Module } from 'wrapper6'
import anime from 'animejs'
import { scrollIt } from '../utils/_scroll-it'

const $ = jQuery

export default class Modal extends Module {
  ready () {
    const body = document.body
    let closing = false

    const addEventBtns = '.open-modal'

    $(document).on('click', addEventBtns, (e) => {
      e.preventDefault()
      const ID = e.currentTarget.getAttribute('data-id')

      openModal(document.querySelector('.modal[data-id="' + ID + '"]'))
    })

    /**
         * Close modals
         */
    const modalOuters = document.querySelectorAll('.modal-outer')
    const closeBtns = document.querySelectorAll('.modal-outer .close-modal')

    for (let i = 0; i < closeBtns.length; i++) {
      const close = closeBtns[i]
      const modal = getClosest(closeBtns[i], '.modal-outer')

      // close modal on button close
      close.addEventListener('click', () => {
        closeModal()
      })

      // close modal on when clicking outside modal
      modal.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal-outer')) {
          closeModal()
        }
      })
    }

    for (let i = 0; i < modalOuters.length; i++) {
      const modalOuter = modalOuters[i]
      modalOuter.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal-outer')) {
          closeModal()
        }
      })
    }

    // close modal on escape
    document.onkeydown = function (evt) {
      evt = evt || window.event

      if (evt.keyCode === 27 && body.classList.contains('modal-open')) {
        closeModal()
      }
    }

    /**
         * Functions
         */

    function openModal (modal) {
      const CONTACT_FORM = document.querySelector('.contact-form-request')

      if (CONTACT_FORM) {
        const pos = CONTACT_FORM.getBoundingClientRect()
        scrollIt(pos.top, 1000, 'easeOutQuad', 150)
        const line1 = $('.line-1')
        const line2 = $('.line-2')
        const line3 = $('.line-3')
        const nav = $('nav#main_nav')
        const body = $('body')

        nav.removeClass('pull_menu_in_out')
        line1.removeClass('line-1-animate')
        line2.removeClass('line-2-remove')
        line3.removeClass('line-3-animate')
        body.removeClass('no-scroll')

        setTimeout(function () {
          nav.css('transition', 'none')
        }, 300)
      } else {
        anime({
          targets: modal.children[0],
          opacity: [0, 1],
          translateY: [-30, 0],
          duration: 300,
          easing: 'easeOutCubic',
          delay: 200
        })

        body.classList.add('modal-open')
        modal.classList.add('active')
      }
    }

    function closeModal () {
      resetCf7()

      if (closing) return false

      closing = true

      setTimeout(() => {
        closing = false
      }, 1000)

      const modal = document.querySelector('.modal-outer.active')

      body.classList.remove('modal-open')

      anime({
        targets: '.modal-inner',
        opacity: [1, 0],
        translateY: [0, -30],
        duration: 300,
        easing: 'easeOutCubic'
      })

      setTimeout(function () {
        modal.classList.remove('active')
      }, 300)

      const modalevent = document.createEvent('Event')
      modalevent.initEvent('modalclosed', true, true)
      modal.dispatchEvent(modalevent)
    }

    function resetCf7 () {
      const inputs = document.querySelectorAll('input.wpcf7-form-control')
      const response = document.querySelector('.wpcf7-response-output')

      setTimeout(() => {
        for (let i = 0; i < inputs.length; i++) {
          inputs[i].classList.remove('wpcf7-not-valid')
        }

        if (response !== null && response.hasOwnProperty('style')) {
          response.style.display = 'none'
        }
      }, 500)
    }

    // find closest element by class
    function getClosest (elem, selector) {
      // Element.matches() polyfill
      if (!Element.prototype.matches) {
        Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function (s) {
                      const matches = (this.document || this.ownerDocument).querySelectorAll(s)
                      let i = matches.length
                      while (--i >= 0 && matches.item(i) !== this) {}
                      return i > -1
                    }
      }

      // Get the closest matching element
      for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem
      }
      return null
    }

    window.closeModal = closeModal // Make method available in global scope
    window.openModal = openModal // Make method available in global scope
    window.getClosest = getClosest // Make method available in global scope
  }
}
